import AuthChecker from '@/Data/WebWorkers/AuthChecker';

export default {
    data() {
        return {
            idleWorkerAuthChecker: {
                worker: null
            }
        };
    },
    watch: {
        '$route.fullPath'(newValue) {
            if (newValue.toLowerCase().indexOf('login') > -1) { }
            else {
                this.clearAuthCheckerWorker();
                this.initAuthCheckerWorker();
            }
        }
    },
    created() {
        this.initAuthCheckerWorker();
    },
    methods: {
        clearAuthCheckerWorker() {
            if (this.idleWorkerAuthChecker.worker != null) {
                this.idleWorkerAuthChecker.worker.terminate();
            }

            this.idleWorkerAuthChecker.worker = null;
            window.AuthCheckerWorkerSet = false;
        },
        initAuthCheckerWorker() {
            this.clearAuthCheckerWorker();
            window.AuthCheckerWorkerSet = true;

            this.idleWorkerAuthChecker.worker = new Worker(window.URL.createObjectURL(AuthChecker(document)), { name: 'AuthWorker' });
            this.idleWorkerAuthChecker.worker.onmessage = (event) => {
                const isLoggedIn = event.data;

                if (isLoggedIn) {
                    this.initAuthCheckerWorker();
                }
                else {
                    this.clearAuthCheckerWorker();
                    this.$router.push({
                        path: '/login'
                    });
                }

            };
        }
    }
};
